// structure of side bar
const menuMap = [
  {
    label: "Tổng quan",
    index: 1,
    icon: "user",
    route: { name: "dashboard" },
  },
  {
    label: "Quản lý Sản phẩm",
    index: 2,
    icon: "user",
    children: [
      {
        label: "Danh mục",
        route: { name: "admin.product_manager.categories" },
      },
      {
        label: "Thương hiệu",
        route: { name: "admin.product_manager.brands" },
      },
      {
        label: "Nhóm",
        route: { name: "admin.product_manager.groups" },
      },
      // {
      //   label: 'Màu sắc',
      //   route: { name: 'admin.product_manager.colors' }
      // },
      {
        label: 'Trạng thái',
        route: { name: 'admin.product_manager.states' }
      },
      // {
      //   label: 'Giới tính',
      //   route: { name: 'admin.product_manager.genders' }
      // },
      {
        label: "Sản phẩm",
        route: { name: "admin.product_manager.products" },
      },
    ],
  },
  {
    label: "Quản lý Bài viết",
    index: 3,
    icon: "user",
    children: [
      {
        label: "Danh mục",
        route: { name: "admin.feed-manager.feeds" },
      },
      {
        label: "Bài viết",
        route: { name: "admin.feed-manager.posts" },
      },
    ],
  },
  {
    label: "Quản lý Tài khoản",
    index: 4,
    icon: "user",
    route: { name: "admin.users" },
  },
  {
    label: "Quản lý Website",
    index: 5,
    icon: "user",
    children: [
      {
        label: "Sliders",
        route: { name: "admin.website-manager.sliders" },
      },
    ],
  },
];

export default menuMap;
